import React from 'react';
import { Link } from 'react-router-dom';

interface EntryLogLinkProps {
    entryLogId: number;
    className?: string;
    children?: React.ReactNode;
}

/**
 * A reusable component for rendering links to entry log pages
 */
const EntryLogLink: React.FC<EntryLogLinkProps> = ({ entryLogId, className = '', children }) => {
    const url = `/user/entryLog/?entryLogId=${entryLogId}`;

    return (
        <Link className={className} to={url}>
            {children || 'View'}
        </Link>
    );
};

export default EntryLogLink;
